// extracted by mini-css-extract-plugin
export default {"userGeneratedCardContainer":"UserGeneratedCard_userGeneratedCardContainer__ha14H","tabsWithStatusWrapper":"UserGeneratedCard_tabsWithStatusWrapper__SEgaD"};